import en from "./en";
import ar from "./ar";

const languages = {
	en: { translation: en },
	ar: { translation: ar },
};

export default languages;
